module.exports = __webpack_public_path__ + "static/img/beijing.5c65a78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/beijing.png
// module id = 6iXB
// module chunks = 1